import { Resource as a } from "@coveo/platform-client";
const t = class t extends a {
  /**
   * Lists all exports generated by the specified schedule.
   *
   * @param scheduleId string, specifies which schedule to filter by when listing exports.
   * @param args Optional RequestInit args, most often used to pass an abort signal.
   * @returns The response{@link ExportModel[]}.
   */
  exportsForSchedule(s, r) {
    return this.api.get(
      this.buildPathWithOrg(`${t.baseUrl}/schedules/${s}/exports`),
      r
    );
  }
  /**
   * Build the request path, handling the optional `org` query parameter.
   *
   * @param route The path part of the request.
   * @param queryParams Optional query parameters object.
   * If this object contains an `org` property, it will override the value from the configuration.
   * @returns The request path including formatted query parameters.
   */
  buildPathWithOrg(s, r) {
    return super.buildPath(s, { org: this.api.organizationId, ...r });
  }
};
t.baseUrl = "/rest/ua/v15/exports";
let i = t;
export {
  i as ExportServiceResource
};
//# sourceMappingURL=ExportServiceResource.js.map
